import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';

type Props = {
  children: React.ReactNode;
};

export default function NoAuthOnly({ children }: Props) {
  const auth = useAuth();
  
  if (auth.isAuth) {
    return (
      <Navigate
        to={{
          pathname: '/',
        }}
      />
    );
  }

  return <>{children}</>;
}
